import '@site/styles/main.scss';

import $ from 'jquery';
import 'jquery-migrate';
import 'jquery-validation';
import 'slick-carousel';
import SmoothScroll from 'smooth-scroll';
import ouibounce from 'ouibounce';
import '../vendor/niceSelect.js';
import { createCookie, readCookie, createDailyCookie, addClass, removeClass, toggleClass, hasClass, scrollTop, setText } from '../vendor/plugins.js';
import { key, searchContext } from '../local.js';

const contextKey = document.body.getAttribute('data-context-key');
(async () => {
	switch (contextKey) {
		case 'cgb':
			await import('@site/scripts/cgb/main.js');
			break;
		case 'gpc':
			await import('@site/scripts/gpc/main.js');
			break;
	}
})();

function isAnyPartOfElementInViewport(el) {
	const rect = el.getBoundingClientRect();
	const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
	const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
	const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
	const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

	return (vertInView && horInView);
}

function randomizeObj(obj) {
	for(var i = obj.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * i);
		var temp = obj[i];
		obj[i] = obj[j];
		obj[j] = temp;
	}

	return obj;
}

var croTestimonialObj = [
	{
		name: 'Suzanne',
		gender: 'F',
		location: 'Suffolk',
		paid: '£211',
		comments: 'We have been giving the house a bit of a spruce up over lockdown, this will help us finish off decorating the bedroom.',
	},
	{
		name: 'Kayleigh',
		gender: 'F',
		location: 'Cumbria',
		paid: '£115',
		comments: 'Spending on kids for summer holidays.',
	},
	{
		name: 'Karen',
		gender: 'F',
		location: 'Leicester',
		paid: '£190',
		comments: 'Got my sons 21st birthday coming up, with the presents and the party it’s going tog et expensive so this will be a great help!',
	},
	{
		name: 'Leanne',
		gender: 'F',
		location: 'Bristol',
		paid: '£318',
		comments: 'Going to have a nice romantic weekend away with my fiancée, think we will head down to Devon... love a good beach walk.',
	},
	{
		name: 'Ian',
		gender: 'M',
		location: 'Stafford',
		paid: '£100',
		comments: 'I’m a carer for my Mum so I will treat her to some nice days out.',
	},
	{
		name: 'Rosemary',
		gender: 'F',
		location: 'London',
		paid: '£618',
		comments: 'Giving money to my granddaughter, she is planning a back-packing trip around Asia.',
	},
	{
		name: 'Harris',
		gender: 'M',
		location: 'Oxford',
		paid: '£137',
		comments: 'My daughters are girl guides and there’s a trip to Borneo so saving for that at the moment.',
	},
	{
		name: 'Alex',
		gender: 'M',
		location: 'Kent',
		paid: '£1,320',
		comments: 'That’s a good lump that will be going straight to the landscapers... can’t wait to have our new garden finished!',
	},
	{
		name: 'Eliza',
		gender: 'F',
		location: 'Dorset',
		paid: '£2,114',
		comments: 'Oooh that will be going in the holiday fund... not sure where we will go yet but feel like doing something special after the year we’ve had!',
	},
];

var croRecentPaidObj = [
	{
		image: '/site/images/cro/paid/1.jpg',
		name: 'Charlie',
		location: 'Gloucester',
		grade: '14ct',
		paid: '£388'
	},
	{
		image: '/site/images/cro/paid/2.jpg',
		name: 'Nitha',
		location: 'Derby',
		grade: '22ct',
		paid: '£1,598'
	},
	{
		image: '/site/images/cro/paid/3.jpg',
		name: 'Doug',
		location: 'Bathgate',
		grade: '9ct',
		paid: '£321'
	},
	{
		image: '/site/images/cro/paid/4.jpg',
		name: 'Matt',
		location: 'Newport',
		grade: '18ct',
		paid: '£271 '
	},
	{
		image: '/site/images/cro/paid/5.jpg',
		name: 'James',
		location: 'Telford',
		grade: '22ct',
		paid: '£362'
	},
	{
		image: '/site/images/cro/paid/6.jpg',
		name: 'Ian',
		location: 'Leeds',
		grade: 'Palladium',
		paid: '£173'
	},
	{
		image: '/site/images/cro/paid/7.jpg',
		name: 'Paula',
		location: 'Oxford',
		grade: '9ct',
		paid: '£60'
	},
	{
		image: '/site/images/cro/paid/8.jpg',
		name: 'Fran',
		location: 'Bristol',
		grade: '22ct',
		paid: '£148'
	},
	{
		image: '/site/images/cro/paid/9.jpg',
		name: 'Donna',
		location: 'Aberdeen',
		grade: '18ct',
		paid: '£1,000'
	},
	{
		image: '/site/images/cro/paid/10.jpg',
		name: 'Jim',
		location: 'Newport',
		grade: '9ct, 18ct',
		paid: '£1,680'
	},
	{
		image: '/site/images/cro/paid/11.jpg',
		name: 'Kate',
		location: 'Suffolk',
		grade: '9ct',
		paid: '£201'
	},
	{
		image: '/site/images/cro/paid/12.jpg',
		name: 'Ken',
		location: 'Glasgow',
		grade: '9ct',
		paid: '£126'
	},
	{
		image: '/site/images/cro/paid/13.jpg',
		name: 'Phil',
		location: 'Lancs',
		grade: '14ct',
		paid: '£62'
	},
	{
		image: '/site/images/cro/paid/14.jpg',
		name: 'Andrew',
		location: 'Devon',
		grade: '9ct, 14ct, 21ct',
		paid: '£852'
	},
	{
		image: '/site/images/cro/paid/15.jpg',
		name: 'Richard',
		location: 'Brighton',
		grade: '9ct',
		paid: '£376'
	},
	{
		image: '/site/images/cro/paid/16.jpg',
		name: 'Patricia',
		location: 'Yorkshire',
		grade: '9ct',
		paid: '£174'
	},
	{
		image: '/site/images/cro/paid/17.jpg',
		name: 'Julie',
		location: 'Burnley',
		grade: '9ct',
		paid: '£242'
	},
	{
		image: '/site/images/cro/paid/18.jpg',
		name: 'Paula',
		location: 'Milton Keynes',
		grade: '14ct, 18ct',
		paid: '£1,437'
	},
	{
		image: '/site/images/cro/paid/19.jpg',
		name: 'Jodie',
		location: 'Bathgate',
		grade: '9ct',
		paid: '£204'
	},
	{
		image: '/site/images/cro/paid/20.jpg',
		name: 'Jack',
		location: 'Warwick',
		grade: '9ct',
		paid: '£119'
	},
	{
		image: '/site/images/cro/paid/21.jpg',
		name: 'Dan',
		location: 'Slough',
		grade: '9ct',
		paid: '£215'
	},
	{
		image: '/site/images/cro/paid/22.jpg',
		name: 'Marion',
		location: 'Llanelli',
		grade: '9ct',
		paid: '£112'
	},
	{
		image: '/site/images/cro/paid/23.jpg',
		name: 'Geoff',
		location: 'Sussex',
		grade: '9ct',
		paid: '£320'
	}
];

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$(document).ready(function(){
	var _window = $(window);

	var vh = _window.innerHeight() * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');

	$('.js-sticky').each(function(index, elSticky){
		var scroll = new SmoothScroll('a[href*="#"]');

		_window.on('DOMContentLoaded load resize scroll', function() {
			var elForm = document.getElementById('side-form');
			isAnyPartOfElementInViewport(elForm) ? removeClass(elSticky, 'show') : addClass(elSticky, 'show');
		});
	});

	_window.on('resize', function() {
		var vh = _window.innerHeight() * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');

		if (readCookie('policyPGFC') !== 'accepted' && ($('.cookie').height() !== $('.cookie .inner').outerHeight())) {
			$('.cookie').height($('.cookie .inner').outerHeight());
		}

		checkStickyTimeCounter();
	});

	// ---
	// Nav
	// ---
	var bodyElem = document.querySelector('body');
	var currentPosY = 0;
	$('.menu-toggle').on('click', function(e) {
		toggleClass(bodyElem, 'menuopen');

		if (bodyElem.classList.contains('menuopen')) {
			var scrollPosY = window.pageYOffset || document.documentElement.scrollTop;
			currentPosY = scrollPosY <= 0 ? 0 : scrollPosY;
			bodyElem.style.position = 'fixed';
		} else {
			bodyElem.style.position = 'initial';
			window.scrollTo(0, currentPosY);
		}
	});

	// Navigate when nav select is changed (for mobile)
	$('.nav-select').on('change', 'select', function(){
		if (this.value !== '')
			window.location = this.value;
	});

	// Use a collapseable mobile nav
	// Currently non-animated version
	$('.js-nav-mobile')
		.on('click', '.nav-mobile-header', function(){
			var _nav = document.querySelector('.nav-mobile');

			toggleClass(_nav, 'open');
		})
		.on('click', '.parent', function(){
			toggleClass(this, 'open');
		})
		.on('click', 'ul, li, a', function(event){
			event.stopPropagation();
		});

	// Automatically set links with a different domain to open in a new window
	$('[href^=http]').each(function(){
		if(this.href.indexOf(window.location.hostname) < 0)
			this.target = '_blank';
	});


	// -----------
	// Nice Select
	// -----------
	$('.js-nice-select').niceSelect();


	// ----
	// Tabs
	// ----
	$('.js-tabs').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						removeClass(sibl[i], 'show');
				}
				addClass(tab, 'show');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i], 'active');
				}
				addClass(this, 'active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + scrollTop() });
				}

				subsequentClick = true;
			})
			.first()
			.click();
	});


	// -----------------
	// Email Obfuscation
	// -----------------
	$('.js-email-hidden')
		.each(function(index, element){
			setText(element, element.getAttribute('data-user') + '@' + element.getAttribute('data-domain'));

			element.href = 'mailto:' + element.getAttribute('data-user') + '@' + element.getAttribute('data-domain');
		});


	// --------------
	// External Links
	// --------------
	$('[rel=external]').attr('target', '_blank');


	// --------------
	// Image Captions
	// --------------
	$('img[title]').each(function(index, element){
		var _image = $(this),
			__figure = $('<figure />'),
			__figcaption = $('<figcaption />');

		var f = this.style.cssFloat || this.style.styleFloat || false;

		if (f === 'left') {
			__figure.addClass('fig-left');
		} else if (f === 'right') {
			__figure.addClass('fig-right');
		}

		_image
			.addClass('fig-img')
			.after(__figure);

		__figcaption
			.text(_image.attr('title'));

		__figure
			.append(_image)
			.append(__figcaption);

		__figure
			.css({
				paddingBottom: __figcaption.outerHeight()
			});

		_image = null;
		__figure = null;
		__figcaption = null;
	});


	// --------------
	// Slick Carousel
	// --------------
	$('.js-cro-2019-12').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 600,
		slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'ease-in-out',
        responsive: [
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            }
        ]
	});

    if ($('.js-customer-review-item').length){
        var randomizedCroTestimonial = randomizeObj(croTestimonialObj);
        randomizedCroTestimonial.forEach(function (obj, idx) {
            var temp = $('.js-customer-review-item')[0];
            var tpl = temp.content ? temp.content.querySelector('*').cloneNode(true) : temp.firstElementChild.cloneNode(true);

            tpl.querySelector('.customer-name').innerHTML = obj.name + ' from ' + obj.location + ' said';
            tpl.querySelector('.customer-comment').innerHTML = '“' + obj.comments + '”';
            tpl.querySelector('.customer-gender').innerHTML = (obj.gender === 'F' ? 'She' : 'He') + ' received ...';
            tpl.querySelector('.amount-text').innerHTML = obj.paid;
            tpl.querySelector('.button').innerHTML = 'Be like ' + obj.name;

            $('.js-reviews-carousel').append(tpl);
        });

        $('.js-reviews-carousel')
            .slick({
                arrows: false,
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 1921,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: false,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 1201,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: false,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    }
                ]
            });
    }

    if ($('.js-recently-paid-item').length){
        var randomizedCroRecentPaid = randomizeObj(croRecentPaidObj);
        randomizedCroRecentPaid.forEach(function (obj, idx) {
            var temp = $('.js-recently-paid-item')[0];
            var tpl = temp.content ? temp.content.querySelector('*').cloneNode(true) : temp.firstElementChild.cloneNode(true);

            tpl.querySelector('.img-container').style.backgroundImage = 'url(' + encodeURI(obj.image) + ')';
            tpl.querySelector('.paid-price').innerHTML = obj.paid;
            tpl.querySelector('.carat-text').innerHTML = obj.grade;
            tpl.querySelector('.location-text').innerHTML = obj.location;

            $('.js-paid-carousel').append(tpl);
        });

        $('.js-paid-carousel')
            .slick({
                arrows: false,
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 6,
                slidesToScroll: 6,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            infinite: false,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: false,
                            dots: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: false,
                            dots: false
                        }
                    }
                ]
            });
    }

	$('.js-home-carousel-cro').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false
			}
		}]
	});

	_ad.checkHeight($('.js-home-carousel-cro .slide-inner'));

	$('.js-home-carousel').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false
			}
		}]
	});

	_ad.checkHeight($('.js-home-carousel .slide-inner'));


	// -------------
	// Time Counter
	// -------------
	var countingDownTime = 0;
	var timeInterval;
	var timeCounterEl = document.querySelector('#timeCounter');
	var $counterEl = $('#timeCounter .counter');
	var $expiredTextEl = $('#timeCounter #expiredText');
	var $sellButtonEl = $('#timeCounter .sell-gold-button');

	var abovetabletmq = window.matchMedia('(min-width: 767px)');
    var $stickyTimeCounterEl = $('#stickyTimeCounter');
    var $stickyTimeEl = $('#counter');
	var $stickyHourEl = $stickyTimeCounterEl?.find('#stickyHour .time-text');
	var $stickyMinuteEl = $stickyTimeCounterEl?.find('#stickyMinute .time-text');
	var $stickySecondEl = $stickyTimeCounterEl?.find('#stickySecond .time-text');

	function convertMS(milliseconds) {
		var day, hour, minute, seconds;

		seconds = Math.floor(milliseconds / 1000);
		minute = Math.floor(seconds / 60);
		seconds = seconds % 60;
		hour = Math.floor(minute / 60);
		minute = minute % 60;
		day = Math.floor(hour / 24);
		hour = hour % 24;

		return {
			day: day,
			hour: hour,
			minute: minute,
			seconds: seconds
		};
	}

	function setTimeCounter(countingTime) {
		// var interval;
        var timeGapMillis = countingTime;
        if(timeCounterEl) {
            var hourEl = timeCounterEl.querySelector('#hour .time-text');
            var minuteEl = timeCounterEl.querySelector('#minute .time-text');
            var secondEl = timeCounterEl.querySelector('#second .time-text');
        } else {
            var stickyTimeCounterEl = document.querySelector('#stickyTimeCounter');
            var hourEl = stickyTimeCounterEl?.querySelector('#stickyHour .time-text');
            var minuteEl = stickyTimeCounterEl?.querySelector('#stickyMinute .time-text');
            var secondEl = stickyTimeCounterEl?.querySelector('#stickySecond .time-text');
        }

		timeInterval = setInterval(function() {
			timeGapMillis = timeGapMillis - 1000;
			var timeGapObj = convertMS(timeGapMillis);

			if (hourEl) {
				hourEl.innerHTML = timeGapObj.hour < 10 ? ('0' + timeGapObj.hour) : timeGapObj.hour;
			}
			if (minuteEl) {
				minuteEl.innerHTML = timeGapObj.minute < 10 ? ('0' + timeGapObj.minute) : timeGapObj.minute;
			}
			if (secondEl) {
				secondEl.innerHTML = timeGapObj.seconds < 10 ? ('0' + timeGapObj.seconds) : timeGapObj.seconds;
			}
			countingDownTime = timeGapMillis;

			if(timeCounterEl) {
				timeGapObj.hour == 0 ? $('#stickyHour').hide() : $stickyHourEl.text(hourEl.innerHTML);
				$stickyMinuteEl.text(minuteEl.innerHTML);
				$stickySecondEl.text(secondEl.innerHTML);
			}

			if (timeGapMillis < 0) {
				clearInterval(timeInterval);
				// createCookie('PGFCSpecial', 'done', 0.001);
				createDailyCookie('PGFCSpecial', 'done');
				$counterEl.hide();
				$expiredTextEl.show();
				$sellButtonEl.addClass('animation');
				$stickyTimeCounterEl.attr('data-expired', 'true');
				$stickyTimeEl.addClass('hide');
			}
		}, 1000);
	}

	var checkStickyTimeCounter = function () {
		var scroll = $(window).scrollTop();
		var bannerHeight = $('.banner').height();

		if (abovetabletmq.matches) {
            if($stickyTimeCounterEl.attr('data-expired') == 'true') {
                $stickyTimeEl.addClass('hide');
                // console.log($stickyTimeEl);
            }
			if (scroll >= bannerHeight) {
				if (!$stickyTimeCounterEl.hasClass('show')) {
					$stickyTimeCounterEl.addClass('show');
				}
			} else {
				$stickyTimeCounterEl.removeClass('show');
			}
		}
	}

	_window.on('scroll', function () {
		checkStickyTimeCounter();
	});

	// -------------
	// Page Specific
	// -------------
	_window.on('load', function() {
		var startTimeCounter = function() {
            var storageTimerMS = localStorage.getItem('timerMS');

            if (storageTimerMS > 0) {
                countingDownTime = storageTimerMS > 0 ? storageTimerMS : 0;
            } else {
                countingDownTime = 300000; // 5 minites in milliseconds
            }

            if (countingDownTime > 0 && readCookie('PGFCSpecial') !== 'done') {
                $counterEl.show();
                $expiredTextEl.hide();
                $sellButtonEl.removeClass('animation');
                setTimeCounter(countingDownTime);
                $stickyTimeCounterEl.attr('data-expired', 'false');
                checkStickyTimeCounter();
            } else {
                $counterEl.hide();
                $expiredTextEl.show();
                $sellButtonEl.addClass('animation');
                $stickyTimeCounterEl.attr('data-expired', 'true');
            }
		}
		startTimeCounter();
	});

    _window.on('beforeunload', function() {
		if (timeCounterEl) {
			var storageTimerMS = localStorage.getItem('timerMS');
			if (storageTimerMS === null && countingDownTime === 0) {
				return;
			}
			localStorage.setItem('timerMS', countingDownTime);
		}
		return;
	});

	// ---------------
	// Form Validation
	// ---------------
	// http://jqueryvalidation.org/validate
	$('.js-form-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div'
		});
	});

	// -----
	// Forms
	// -----
	$('.js-form-pack')
		.each(function(index, elForm){
			var elSelect = elForm.querySelector('.js-form-pack-select'),
				elAddr = elForm.querySelector('.side-form_address'),
				elAddrFields = elForm.querySelector('.side-form_address-fields'),
				elAddrInputs = elForm.querySelectorAll('.address-input'),
				elAddrEdit = elForm.querySelector('.side-form_address-edit'),
				elAddr1 = elAddrInputs[0],
				elTriggerValidation = elForm.querySelector('.js-trigger-validation'),
				elPostcode = elForm.querySelector('.request-postcode'),
				elSubmit = elForm.querySelector('button[type="submit"]'),
				_form = $(elForm);

			// Honeypot: HTML action is /spam/; real target is data-action (bots without JS stay on /spam/)
			_form.attr('action', _form.data('action'));

			_form
				.validate({
					errorContainer: elForm.querySelector('.js-error-container'),
					errorLabelContainer: elForm.querySelector('.js-error-container'),
					errorPlacement: function(error, element){
						var target = element;

						if (element.parent().hasClass('niceselect-wrapper')) {
							target = element.parent();
						}

						target.after(error);
					},
					submitHandler: function(form){
						if (hasClass(elAddr, 'show')) {
							if (elSubmit) {
								elSubmit.disabled = true;
								elSubmit.innerText = 'Submitting...';
							}

							form.submit();
						} else {
							$.ajax({
								url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
								dataType: "jsonp",
								data: {
									key: key,
									searchFor: "Everything",
									searchTerm: elPostcode.value,
									lastId: searchContext
								},
								success: function(data) {
									var _options = ['<option value="">Please select your address</option>']
									$.each(data.Items, function(k,item) {
										_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
									});
									$(elSelect).html(_options.join(''));
									// $('.side-form_address-select').html(_options.join(''));
								}
							});

							addClass(elAddr, 'show');
						}
					},
					wrapper: 'div'
				});

			$(elPostcode)
				.on('input change', function(){
					if (elPostcode.value.length < 5) return;

					if (hasClass(elAddr, 'show')) {
						$(elForm).find('.side-form_address-select').html('<option value="">Getting addresses...</option>');

						$.ajax({
							url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
							dataType: "jsonp",
							data: {
								key: key,
								searchFor: "Everything",
								searchTerm: $("#request-postcode").val(),
								lastId: searchContext
							},
							success: function(data) {
								var _options = ['<option value="">Please select your address</option>']
								$.each(data.Items, function(k,item) {
									_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
								});
								$(elForm).find('.side-form_address-select').html(_options.join(''));
							}
						});
					}
				});

			$(elTriggerValidation)
				.on('click', function(){
					removeClass(elAddrFields, 'show');

					if (_form.valid()) {
						addClass(elAddr, 'show');
					}
				});

			$(elSelect)
				.on('change', function(event){
					addClass(elAddrEdit, 'show');

					$.ajax({
						url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws",
						dataType: "jsonp",
						data: {
							key: key,
							id: elSelect.value
						},
						success: function (data) {
							if (data.Items.length) {
								var _ad = data.Items[0];
								if(!_ad.Line1) {
									$(elForm).find('.side-form_address').addClass('show');
									$(elForm).find('.side-form_address-fields').addClass('show');
								}

								$(elForm).find('.addr1').val(_ad.Line1);
								$(elForm).find('.addr2').val(_ad.Line2);
								$(elForm).find('.addr3').val(_ad.Line3);
								$(elForm).find('.town').val(_ad.City);
								$(elForm).find('.county').val(_ad.Province);
							}
						}
					});

				});

			$(elAddrEdit)
				.on('click', '.js-address-edit', function(event){
					addClass(elAddrFields, 'show');
				});
        });

    $(document.querySelector('.js-cro-toggle'))
        .on('click', function(e){
            e.preventDefault();
            const el = document.querySelector('.js-cro-hide');
            const bg = document.querySelector('.bg');
            if(el) {
                if(el.classList.contains('show')) {
                    el.classList.remove('show');
                    // bg.style.height = "calc(100vh - 82px)";
                } else {
                    el.classList.add('show');
                    // bg.style.height = "150vh";
                }
            }
        });

	$(document).on('click', '.js-cro-show', function(e) {
            e.preventDefault();
            const elFrm = document.querySelector('.js-cro-form');
            if(elFrm) {
                elFrm.classList.toggle('show');
            }
        });

    $(document.querySelector('.js-cro-close'))
        .on('click', function(e){
            e.preventDefault();
            const elFrm = document.querySelector('.js-cro-form');
            if(elFrm) {
                elFrm.classList.toggle('show');
            }
        });


    $('.js-form-cro')
		.each(function(index, elForm){
			var elSelect = elForm.querySelector('.js-form-pack-select'),
				elAddr = elForm.querySelector('.side-form_address'),
				elAddrEditGroup = elForm.querySelector('.side-form_address-edit-group'),
				elAddrFields = elForm.querySelector('.side-form_address-fields'),
				elAddrInputs = elForm.querySelectorAll('.address-input'),
				elAddrEdit = elForm.querySelector('.side-form_address-edit'),
				elAddr1 = elAddrInputs[0],
				elTriggerValidation = elForm.querySelector('.js-trigger-validation'),
                elPostcode = elForm.querySelector('.request-postcode'),
                elFindAddr = elForm.querySelectorAll('.js-find-addr'),
                elEnterAddrManually = elForm.querySelector('.js-enter-addr-manually'),
                elSubmit = elForm.querySelector('button[type="submit"]'),
				_form = $(elForm);

			// Honeypot: HTML action is /spam/; real target is data-action (bots without JS stay on /spam/)
			_form.attr('action', _form.data('action'));

			function manualAddressOpen() {
				return !!(elAddrFields && hasClass(elAddrFields, 'show'));
			}

			function hideAddressSelectError() {
				if (elSelect && manualAddressOpen() && _form.data('validator')) {
					$(elSelect).valid();
				}
			}

			_form
				.validate({
					rules: {
						address: {
							required: {
								depends: function() {
									return !manualAddressOpen();
								}
							}
						}
					},
					errorContainer: elForm.querySelector('.js-error-container'),
					errorLabelContainer: elForm.querySelector('.js-error-container'),
					errorPlacement: function(error, element){
						var target = element;

						if (element.parent().hasClass('niceselect-wrapper')) {
							target = element.parent();
						}

						target.after(error);
					},
					submitHandler: function(form){
						if (hasClass(elAddr, 'show') && hasClass(elAddrEditGroup, 'show')) {
							if (elSubmit) {
								elSubmit.disabled = true;
								elSubmit.innerText = 'Submitting...';
							}

							form.submit();
						} else {
							$.ajax({
								url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
								dataType: "jsonp",
								data: {
									key: key,
									searchFor: "Everything",
									searchTerm: elPostcode.value,
									lastId: searchContext
								},
								success: function(data) {
									var _options = ['<option value="">Please select your address</option>']
									$.each(data.Items, function(k,item) {
										_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
									});
									$(elSelect).html(_options.join(''));
									// $('.side-form_address-select').html(_options.join(''));
								}
							});

							addClass(elAddr, 'show');
							addClass(elAddrEditGroup, 'show');
						}
					},
					wrapper: 'div'
				});

            $(elFindAddr).each(function(idx, elFindAddrItem){
				$(elFindAddrItem).on('click', function(){
                    if(elPostcode.value != '') {
						if (elEnterAddrManually.classList.contains('hidden')) {
							elEnterAddrManually.classList.remove('hidden');
						}

                        $.ajax({
                            url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
                            dataType: "jsonp",
                            data: {
                                key: key,
                                searchFor: "Everything",
                                searchTerm: elPostcode.value,
                                lastId: searchContext
                            },
                            success: function(data) {
                                var _options = ['<option value="">Please select your address</option>']
                                $.each(data.Items, function(k,item) {
                                    _options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
                                });
                                $(elSelect).html(_options.join(''));
                                // $('.side-form_address-select').html(_options.join(''));
                            }
                        });

                        addClass(elAddr, 'show');
						addClass(elAddrEditGroup, 'show');
                    } else {
                        const elError = document.querySelector('.js-postcode-error') !== null;
                        if(!elError) {
                            elPostcode.insertAdjacentHTML('afterend', '<div class="js-postcode-error"><label for="request-postcode" class="error" style="display: inline;">Please enter your postcode</label></div>');
                        }
                    }
                });
			});

			$(elPostcode)
				.on('input change', function(){
					if (elPostcode.value.length < 5) return;

					if (hasClass(elAddr, 'show') && hasClass(elAddrEditGroup, 'show')) {
						$(elForm).find('.side-form_address-select').html('<option value="">Getting addresses...</option>');

						$.ajax({
							url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
							dataType: "jsonp",
							data: {
								key: key,
								searchFor: "Everything",
								searchTerm: $("#request-postcode").val(),
								lastId: searchContext
							},
							success: function(data) {
								var _options = ['<option value="">Please select your address</option>']
								$.each(data.Items, function(k,item) {
									_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
								});
								$(elForm).find('.side-form_address-select').html(_options.join(''));
							}
						});
					}
                });

			$(elTriggerValidation)
				.on('click', function(){
					removeClass(elAddrFields, 'show');

					if (_form.valid()) {
						addClass(elAddr, 'show');
						addClass(elAddrEditGroup, 'show');
					}
				});

			$(elSelect)
				.on('change', function(event){
					addClass(elAddrEdit, 'show');

					$.ajax({
						url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws",
						dataType: "jsonp",
						data: {
							key: key,
							id: elSelect.value
						},
						success: function (data) {
							if (data.Items.length) {
								var _ad = data.Items[0];
								if(!_ad.Line1) {
									$(elForm).find('.side-form_address').addClass('show');
									$(elForm).find('.side-form_address-fields').addClass('show');
									hideAddressSelectError();
								}

								$(elForm).find('.addr1').val(_ad.Line1);
								$(elForm).find('.addr2').val(_ad.Line2);
								$(elForm).find('.addr3').val(_ad.Line3);
								$(elForm).find('.town').val(_ad.City);
								$(elForm).find('.county').val(_ad.Province);
							}
						}
					});

				});

			$(elAddrEdit)
				.on('click', '.js-address-edit', function(event){
					addClass(elAddrFields, 'show');
					hideAddressSelectError();
				});

			$(elEnterAddrManually)
				.on('click', function(event){
					$(elForm).find('.side-form_address').addClass('show');
					$(elForm).find('.side-form_address-fields').addClass('show');

					$(elForm).find('.addr1').val('');
					$(elForm).find('.addr2').val('');
					$(elForm).find('.addr3').val('');
					$(elForm).find('.town').val('');
					$(elForm).find('.county').val('');
					hideAddressSelectError();
				});
		});

	// ----------
	// Accordions
	// ----------
	var stopClick = false;
	$('.js-accordion-trigger').off().on('click', function (e) {
		e.preventDefault();
		if(stopClick) return;
		stopClick = true;

		if ($(this).hasClass('open')) {
			$(this).removeClass('open').next().stop(true, true).slideUp(400, function() { stopClick = false; });
		} else {
			$(this).addClass('open').next().stop(true, true).slideDown(400, function() { stopClick = false; });
		}

		$('.js-accordion-trigger').not(this).each(function() {
			if ($(this).hasClass('open')) {
				$(this).removeClass('open').next().slideUp();
			}
		});

		return false;
	});

	// -----------
	// Page Button
	// -----------
	$('.js-page-button')
		.on('click', function(event){
			event.preventDefault();

			$('html,body')
				.animate({ scrollTop: $('.side-form').offset().top });

			var elInputFirst = document.querySelector('.side-form input');
			elInputFirst.focus();
		});


	// -------
	// Cookies
	// -------
	if (readCookie('policyPGFC') !== 'accepted') {
		var _cookie = $('.cookie'),
			_inner = _cookie.find('.inner');

		_cookie
			.removeClass('hide');

		_cookie.height(_inner.outerHeight());

		$('.js-accept-cookies')
			.on('click', function(){
				createCookie('policyPGFC', 'accepted', 365);
				_cookie
					.height(0);
			});
	} else {
		createCookie('policyPGFC', 'accepted', 365);
	}


	// -------------
	// Media Queries
	// -------------
	(function(){
		var updateTel = function(mq){
			if (mq.matches) {
				$('[data-tel]')
					.each(function(index, el){
						var _el = $(el);
						_el.attr('href', 'tel:'+_el.data('tel'));
					});
			} else {
				$('[data-tel]').removeAttr('href');
			}
		};
		if (window.matchMedia) {
			var mq = window.matchMedia( "(max-width: 767px)" );

			if (mq.addListener) mq.addListener(updateTel);
			updateTel(mq);
		}
	})();


	// --------------------
	// Placeholder Function
	// --------------------
	function placeholderFunc(index, element){
		var ph = element.getAttribute('placeholder'),
			_input = $(this);

		_input.on({
			focus: function(){
				if (element.value == ph) {
					element.value = '';
					removeClass(element, 'placeholder-replacement');
				}
			},
			blur: function(){
				if (element.value == "") {
					element.value = ph;
					addClass(element, 'placeholder-replacement');
				}
			}
		}).blur();
	}


	// -----------
	// Placeholder
	// -----------
	if(!Modernizr.input.placeholder)
	{
		$('html').addClass('no-placeholder');

		$('form:not(.js-no-placeholder)').each(function(index, elForm){
			$(elForm).find('[placeholder]').each(placeholderFunc);
		});
	}

	// ---------------------
	// Custom Youtube Player
	// ---------------------
	function Video(videoID) {
		const self = this;

		self.videoEl = $(videoID);
        self.playOverlay = self.videoEl.find('.video-player-overlay');
        self.playButton = self.playOverlay.find('.yt-player-trigger-play');
        self.iframeId = self.videoEl.find('iframe').attr('id');
        self.player = null;

		self.setPlayer = function(player) {
			self.player = player;
		}

		self.onPlayerReady = function() {
			if (self.playButton) {
				self.playButton.on('click', self.handlePlayButtonClick.bind(self));
			}
		}

		self.handlePlayButtonClick = function(event) {
			event.preventDefault();
			event.stopPropagation();

			self.playOverlay.addClass('hidden');
			self.player.playVideo();
		}
	}

	function Videos() {
		const self = this;

		self.players = [];
		self.queue = [];

		self.add = function(video) {
			self.queue.push(video);
		}

		self.load = function() {
			window.onYouTubePlayerAPIReady = function() {
				self.queue.forEach(function(video) {
					var player = new YT.Player(video.iframeId, {
						events: {
							'onReady': video.onPlayerReady.bind(video)
						}
					});
					video.setPlayer(player);
				})
			}.bind(self);
		}
	}

	if ($('.video-clip')) {
		var videos = new Videos();

		$('.video-clip').each(function(idx, videoEl) {
			var targetVideoObj = new Video('#' + $(videoEl).attr('id'));
			videos.add(targetVideoObj);
		})

		videos.load();
	}

	$('.js-form-cro-telephone').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div',
			submitHandler: function (form) {
				var $form = $(form);
				$.ajax({
					type: "POST",
					url: "/assets/components/pgfc/updateAPackValidated.php",
					data: $form.serializeArray().reduce(function(obj, item) {
						obj[item.name] = item.value;
						return obj;
					}, {}),
					success: function(response) {
						console.log(response);
						if (response == 1) {
							window.dataLayer.push({
								event: 'phone_added'
							});

							$form.find(".form-field").fadeOut(300, function () {
								$form.find(".thankyou-message").fadeIn(300);
							});
						} else {
							// Optionally show an error message
							alert("There was a problem submitting your telephone number. Please try again.");
						}
					},
					error: function() {
						alert("There was a problem submitting your telephone number. Please try again.");
					}
				});
				return false;
			}
		});
	});

	const tickerContainer = document.querySelector(".ticker-container");
	if (tickerContainer) {
		const tickerMask = tickerContainer.querySelector(".ticker-mask");
		const tickerTrack = tickerContainer.querySelector(".ticker-track");
		const leftBtn = tickerContainer.querySelector(".ticker-arrow-prev");
		const rightBtn = tickerContainer.querySelector(".ticker-arrow-next");
		const originalHTML = tickerTrack.innerHTML;
		let speed = 1;
		let position = 0;
		let loopWidth = 0;
		let isDragging = false;
		let startX = 0;
		let scrollStart = 0;
		let paused = false;

		function wrapPosition() {
			if (!loopWidth) return;
			// Map into (-loopWidth, 0] using a cached one-set width.
			// Remeasuring scrollWidth/2 every frame jitters under transform → visible jump.
			position = ((position % loopWidth) + loopWidth) % loopWidth;
			if (position !== 0) position -= loopWidth;
		}

		function setupTrack() {
			tickerTrack.innerHTML = originalHTML;
			tickerTrack.style.transform = 'translateX(0)';
			loopWidth = tickerTrack.scrollWidth;
			if (!loopWidth) return;

			const targetWidth = Math.max(tickerMask.offsetWidth * 2, loopWidth * 2);
			let guard = 0;
			while (tickerTrack.scrollWidth < targetWidth && guard < 16) {
				tickerTrack.insertAdjacentHTML('beforeend', originalHTML);
				guard++;
			}
			wrapPosition();
			tickerTrack.style.transform = `translateX(${position}px)`;
		}
		setupTrack();

		function animateTicker() {
			if (!isDragging && !paused && loopWidth) {
				position -= speed;
				wrapPosition();
				tickerTrack.style.transform = `translateX(${position}px)`;
			}
			requestAnimationFrame(animateTicker);
		}
		animateTicker();

		// Hover to pause
		tickerMask.addEventListener('mouseenter', () => paused = true);
		tickerMask.addEventListener('mouseleave', () => paused = false);

		// Buttons
		leftBtn.addEventListener('mousedown', () => speed = -2);
		leftBtn.addEventListener('mouseup', () => speed = 1);
		leftBtn.addEventListener('mouseleave', () => speed = 1);
		rightBtn.addEventListener('mousedown', () => speed = 2);
		rightBtn.addEventListener('mouseup', () => speed = 1);
		rightBtn.addEventListener('mouseleave', () => speed = 1);

		// Unified drag handler
		function handleDragStart(e) {
			isDragging = true;
			startX = e.clientX || e.touches[0].clientX;
			scrollStart = position;
			if (e.cancelable) e.preventDefault();
		}

		function handleDragMove(e) {
			if (isDragging) {
				const clientX = e.clientX || e.touches[0].clientX;
				position = scrollStart + (clientX - startX);
				wrapPosition();
				tickerTrack.style.transform = `translateX(${position}px)`;
				if (e.cancelable) e.preventDefault();
			}
		}

		function handleDragEnd() {
			isDragging = false;
		}

		// Mouse drag
		tickerMask.addEventListener('mousedown', handleDragStart);
		window.addEventListener('mousemove', handleDragMove);
		window.addEventListener('mouseup', handleDragEnd);

		// Touch drag with passive: false for preventDefault
		tickerMask.addEventListener('touchstart', handleDragStart, { passive: false });
		tickerMask.addEventListener('touchmove', handleDragMove, { passive: false });
		tickerMask.addEventListener('touchend', handleDragEnd);

		window.addEventListener('resize', setupTrack);
	}

	// ---------------------
	// For Youtube carousel
	// ---------------------
	// let players = [];

	// window.onYouTubeIframeAPIReady = function() {
	// 	console.log('onYouTubeIframeAPIReady');
	// 	$('.main-slider iframe').each(function(i, el) {
	// 		const player = new YT.Player(el);
	// 		players.push(player);
	// 	});
	// }

	// $('.main-slider').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	fade: true,
	// 	asNavFor: '.thumbnail-carousel'
	// });

	// $('.thumbnail-carousel').slick({
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.main-slider',
	// 	dots: false,
	// 	centerMode: false,
	// 	focusOnSelect: true,
    //     responsive: [
    //         {
    //             breakpoint: 540,
    //             settings: {
    //                 slidesToShow: 2,
    //             }
    //         }
    //     ]
	// });

	// // Pause all videos before changing slide
	// $('.main-slider').on('beforeChange', function() {
	// 	players.forEach(p => p.pauseVideo && p.pauseVideo());
	// });

	// // Autoplay video when slide changes
	// $('.main-slider').on('afterChange', function(event, slick, currentSlide) {
	// 	const player = players[currentSlide];
	// 	if (player && player.playVideo) player.playVideo();
	// });
	// ---------------------
	// ouibounce
	// ---------------------
	if (contextKey === 'web') {
		var _disabledOuibounce = false;

		// if you want to use the 'fire' or 'disable' fn,
		// you need to save OuiBounce to an object
		var _ouibounce = ouibounce(document.getElementById('ouibounce-modal'), {
			aggressive: false,
			timer: 30000, //30 seconds
			cookieExpire: 30, //30 days
			sitewide: true
		});

		if (_disabledOuibounce) {
			_ouibounce.disable({ cookieExpire: 30, sitewide: true });
		}

		$('body').on('click', function () {
			$('#ouibounce-modal').hide();
		});

		// $('#ouibounce-modal .modal .order-pack').on('click', function () {
		//	$('#ouibounce-modal').hide();
		//	$('.focus-field').focus();
		// });

		$('#ouibounce-modal .modal .close').on('click', function (e) {
			e.preventDefault();
			$('#ouibounce-modal').hide();
		});

		$('#ouibounce-modal .modal').on('click', function(e) {
			if (e.target.closest('.js-cro-show')) return;
			e.stopPropagation();
		});
	}
});